import { render, staticRenderFns } from "./PaqueteDocumentoIndex.vue?vue&type=template&id=369a195c"
import script from "./PaqueteDocumentoIndex.vue?vue&type=script&lang=js"
export * from "./PaqueteDocumentoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports